<template>
  <div>
    <b-card class="mb-3" :bg-variant="type=='buy' ? 'dark' : 'success'">
      <h3 class="text-white-50">Toplam {{ type == 'buy' ? 'Alınan' : 'Satılan' }} Ürün Miktarı</h3>
      <h1 class="text-white">{{ type == 'buy' ? getTotalBuy : getTotalSale }} TL</h1>
    </b-card>
    <b-card class="mb-4">
      <b-card-header>
        <div class="row align-items-center justify-content-between d-flex">
          <h3>{{ title }}</h3>
          <div>
            <b-button @click="toPdf({id:$route.params.id})" variant="info">Rapor Al</b-button>
            <b-button @click="product={}; editMode=0; $refs.modal.show()" variant="primary">Ekle</b-button>
          </div>
        </div>
      </b-card-header>
      <b-table ref="table" thead-class="thead-light" :items="getData" :fields="[
          {key: 'title', label: 'Ürün Adı'},
          {key: 'price', label: 'Fiyatı'},
          {key: 'piece', label: 'Miktar'},
          {key: 'brand', label: 'Marka'},
          {key: 'created_at', label: 'Tarih'},
          {key: 'actions', label: ''},
        ]"
               responsive show-empty
      >
        <template v-slot:table-busy>
          <div style="width: 100%; text-align:center;">
            <b-spinner label="Spinning"></b-spinner>
          </div>
        </template>

        <template v-slot:empty>
          <b-alert variant="warning" show>{{ $t("Henüz bir şey eklenmemiş") }}!</b-alert>
        </template>

        <template v-slot:cell(price)="data">
          {{ data.item.price }} TL
        </template>

        <template v-slot:cell(created_at)="data">
          {{ moment(data.item.created_at).format('DD/MM/YYYY') || '' }}
        </template>

        <template v-slot:cell(actions)="data">
          <div class="d-flex">
            <b-button variant="info" @click="setUpdateMode(data.item)" size="sm" class="mb-1">
              {{ $t("Düzenle") }}
            </b-button>
            <b-button variant="danger" size="sm" @click="product=data.item; $refs.sureModal.show()" class="">
              {{ $t("Sil") }}
            </b-button>
          </div>
        </template>

      </b-table>
      <div class="w-100 text-center d-flex-wrap align-items-center justify-content-center mt-2 mb-3">
        <b-button variant="secondary" v-if="cPage!=1" @click="cPage=1; refreshTable();"><<</b-button>
        <b-button variant="secondary" v-if="cPage!=1"
                  @click="cPage-10>=1 ? cPage=cPage-10 : cPage=1; refreshTable();"><
        </b-button>
        <b-button :variant="cPage==page ? 'primary':'secondary'" v-for="page in items.last_page"
                  @click="cPage=page; refreshTable();" v-bind:key="page" v-if="page<(cPage+5) && (page>cPage-5)">
          {{ page }}
        </b-button>

        <b-button variant="secondary" v-if="cPage!=items.last_page"
                  @click="cPage+10<=items.last_page ? cPage=cPage+10 : cPage=items.last_page; refreshTable();">
          >
        </b-button>
        <b-button variant="secondary" v-if="cPage!=items.last_page"
                  @click="cPage=items.last_page; refreshTable();"> >>
        </b-button>
      </div>


    </b-card>
    <b-modal :title="`${editMode  ? '' : title.replace('ler','')} ${editMode ? product.title+' Düzenle' : 'Ekle'}`"
             ref="modal">
      <b-form-group :label="$t('Ürün Adı')">
        <b-form-input v-model="product.title"/>
      </b-form-group>
      <b-form-group :label="$t('Marka')">
        <b-form-input v-model="product.brand"/>
      </b-form-group>
      <b-form-group :label="$t('Miktarı')">
        <b-form-input type="number" v-model="product.piece"/>
      </b-form-group>
      <b-form-group :label="$t('Son Ödeme Tarihi')">
        <b-form-input type="date" v-model="product.last_payment_date"/>
      </b-form-group>
      <b-form-group :label="$t('Fiyatı')">
        <b-form-input type="number" v-model="product.price"/>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="resetAndHideModal">{{ $t("İptal") }}</b-button>
        <b-button variant="primary" @click="editMode ? updateProduct() : submitModal()">{{ $t("Kaydet") }}</b-button>
      </template>
    </b-modal>

    <b-modal title="Emin Misiniz" ref="sureModal">
      Ürünü Silmek İstediğinize Emin Misiniz?
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="deleteProduct">{{ $t("Sil") }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapState, mapGetters} from "vuex";
import moment from "moment";

export default {
  props: ['type', 'title', 'id'],
  computed: {
    ...mapGetters(['getTotalSale', 'getTotalBuy']),
    createdAt() {
      return moment()
    }
  },
  methods: {
    ...mapActions(['getClientProducts', 'storeClientProduct', 'deleteClientProduct', 'updateClientProduct', 'toPdf']),
    moment,
    refreshTable() {
      this.$refs.table.refresh()
    },
    async deleteProduct() {
      await this.deleteClientProduct(this.product.id).then(res => {
        this.success(res.data.message)
      }).catch(err => {
        this.error(err.response.data.message)
      })
      this.$refs.sureModal.hide()
      this.$refs.table.refresh()
    },
    async updateProduct() {
      await this.updateClientProduct(this.product).then(res => {

        this.success(res.data.message)
      }).catch(err => {
        this.error(err.response.data.message)
      })
      this.$refs.modal.hide()
      this.$refs.table.refresh()
    },
    async getData() {
      await this.getClientProducts({id: this.id, type: this.type, page: this.cPage}).then(res => {
        this.items = res.data.products

        console.log("items", this.items)

      }).catch(err => {
        alert('TEST')
        this.error(err.response.data.message)
      })
      return this.items.data

    },
    setUpdateMode(product) {
      this.editMode = 1;
      this.product = product;
      this.$refs.modal.show()
    },
    submitModal() {
      this.storeClientProduct({...this.product, client_id: this.id, type: this.type})
          .then(async res => {
            this.success(res.data.message)
            this.$refs.table.refresh()
            this.$refs.modal.hide()
          }).catch(err => {
        this.error(err.response.data.message)
      })
    },
    resetAndHideModal() {
      this.product = {}
      this.$refs.modal.hide()
    }
  },
  data() {
    return {
      ...mapState(['totalSale']),
      cPage: 1,
      items: [],
      product: {
        title: '',
        price: 0,
        last_payment_date: moment(),
        piece: 1,
      },
      editMode: 0,
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>